/* eslint-disable max-lines */
import $ from 'jquery';
import {triggerEvent} from '../../vendor/googletagmanager/events';

let suggestionsData = null;
const smartSuggestions = {
    init: function () {
        this.getSuggestionsForCustomer().done(
            function (data) {
                this._getAllSmartSuggestions(data);
            }.bind(this)
        );
    },
    getSuggestionsForCustomer: function () {
        var dfd = new $.Deferred();

        if (suggestionsData) {
            dfd.resolve(suggestionsData);
        } else {
            $.get('/api/supplementrecommendation/GetSmartSuggestionsForCustomer').done(function (response) {
                if (response.status === smartPak.HTTP_STATUS_OK) {
                    suggestionsData = response.content;
                    dfd.resolve(suggestionsData);
                }
            });
        }

        return dfd.promise();
    },
    _getAllSmartSuggestions: function (data) {
        var hasSuggestion = data.customerHasSuggestions,
            firstItemWithSuggestions = data.accountSuggestions.filter(suggestion => suggestion.hasSuggestions)[0];

        if (hasSuggestion && firstItemWithSuggestions) {
            this._createSuggestions(firstItemWithSuggestions, data);
        }
    },
    _populateRibbon: function (data) {
        const $ribbon = document.getElementById('site-ribbon'),
            message =
                '<a href="#" class="learnSuggestion" data-event-category="' +
                data.eventCategory +
                '" data-event-action="Click" data-event-label="' +
                data.ruleName +
                '">' +
                '<span class="smartSuggest">' +
                'SmartSuggestions: ' +
                data.headline +
                '. (<span class="link">Learn why</span>)' +
                '</span></a>';

        data.eventCategory = 'SmartSuggestions-Responsive-SitewideRibbon';

        if (!$ribbon) {
            return;
        }

        if ($ribbon && $ribbon.rotatingMessageRibbon) {
            $ribbon.rotatingMessageRibbon.push(message);
        } else {
            $($ribbon)
                .find('ul')
                .append('<li id="suggestion-ribbon-message">' + message + '</li>');
        }

        this._triggerEvent(data.eventCategory, 'View', data.ruleName);
        this._addEventListeners($('.learnSuggestion'), data);
    },
    _createSuggestions: function (data) {
        this._populateRibbon(this.extendRecommendations(data)[0]);
        this._bindEvents(data.suggestions[0].ruleName);
        smartPak.recentlyViewedProducts.loadBvReviewStars('.suggestionReviewStars');
    },
    _getProductAttributes: function (id, $element) {
        smartPak.api.product.getProductClassWithAttributes(id).done(
            function (data) {
                this._suggestedProduct(data, $element);
            }.bind(this)
        );
    },
    _suggestedProduct: function (data, $element) {
        var $suggestProd = $element.find('.suggestProd');

        $suggestProd.html('');
        $suggestProd.prepend(this._buildSuggestedProdHTML(data.Content));
    },
    _buildSuggestedProdHTML: function (product) {
        return (
            '<div class="productInfo">' +
            '<div>' +
            '<a href="' +
            product.Url +
            '">' +
            '<img src="' +
            product.WebImage +
            '?width=180" height="180" alt="' +
            product.Title +
            '" />' +
            '</a>' +
            '</div>' +
            '<div class="product">' +
            '<a href="' +
            product.Url +
            '">' +
            product.Title +
            '</a>' +
            '</div>' +
            '<div>' +
            '<span class="price">' +
            product.Price +
            '</span>' +
            '</div>' +
            '<div class="reviews">' +
            '<div class="suggestionReviewStars styleReviews jsHide" data-bv-show="inline_rating" data-bv-product-id="' +
            product.Id +
            '"></div>' +
            '</div>' +
            '</div>'
        );
    },
    _bindEvents: function (ruleName) {
        $('body').on(
            'click',
            '.productListItem .suggstPCP',
            function () {
                this._triggerEvent('SmartSuggestions-Mobile-SearchProd', 'Click', ruleName);
            }.bind(this)
        );
    },
    _triggerEvent: function (category, action, label) {
        triggerEvent(category, action, label);
    },
    buildModal: function (recommendation, id, productDetails) {
        return $(
            '<div id="' +
                id +
                '" class="jsHide"><p>' +
                recommendation.justification +
                '</p>' +
                '<div class="product-recommendation-details">' +
                '<div><img src="' +
                productDetails.src.split('?')[0] +
                '?width=100' +
                '" alt="' +
                productDetails.name +
                '" /></div>' +
                '<div>' +
                '<div class="product-recommendation-details-name">' +
                productDetails.name +
                '</div>' +
                '<div class="product-recommendation-details-reviews searchReviewStars styleReviews" data-bv-show="inline_rating" data-bv-product-id="' +
                recommendation.suggestedProductClassId +
                '" ></div>' +
                '<div class="product-recommendation-details-price">' +
                productDetails.price +
                '</div>' +
                '</div>' +
                '<div class="button-row wide">' +
                '<a class="secondary purchase button product-recommendations-wishlist" data-size="sm" href="#" data-recommendation-productClassId="' +
                recommendation.suggestedProductClassId +
                '">Save to Wishlist</a>' +
                '<a class="purchase button" data-size="sm" href="' +
                productDetails.url +
                '">Buy Now</a>' +
                '</div>' +
                '</div>' +
                '<p>Not interested? <a href="#" class="product-recommedation-dismiss" data-recommendation-productClassId="' +
                recommendation.suggestedProductClassId +
                '" data-event-category="' +
                (recommendation.eventCategory || '') +
                '" data-event-action="Dismiss" data-event-label="' +
                (recommendation.ruleName || '') +
                '">Click here to hide</a></p>' +
                '</div>'
        );
    },
    _addEventListeners: function ($element, recommendation, onClick) {
        $($element).on(
            'click',
            function (e) {
                if (
                    e.currentTarget.dataset.eventCategory &&
                    e.currentTarget.dataset.eventAction &&
                    e.currentTarget.dataset.eventLabel
                ) {
                    triggerEvent(
                        e.currentTarget.dataset.eventCategory,
                        e.currentTarget.dataset.eventAction,
                        e.currentTarget.dataset.eventLabel
                    );
                }

                smartPak.api.product.getProductClassWithAttributes(recommendation.suggestedProductClassId).done(
                    function (data) {
                        this.addResultText([recommendation]);

                        var content = data.Content,
                            productDetails = {
                                name: content.Name,
                                url: content.Url,
                                price: content.Price,
                                src: content.ImagePath
                            };

                        smartPak.ui.modal(
                            this.buildModal(recommendation, this.buildSelector(recommendation), productDetails)[0],
                            {
                                removeContents: true,
                                title: 'SmartSuggestion',
                                modalClass: 'product-recommendation-modal',
                                width: 550,
                                open: this.handleModalOpen(function () {
                                    $element.remove();
                                })
                            }
                        );
                    }.bind(this)
                );

                if ($.isFunction(onClick)) {
                    onClick();
                }
            }.bind(this)
        );
    },
    dismissById: function (id) {
        return $.ajax({
            url: '/api/SupplementRecommendation/DismissSmartSuggestionResultFromDisplayForCustomer/' + id,
            type: 'PUT',
            data: null,
            contentType: 'application/json'
        });
    },
    handleModalOpen: function (remove) {
        return modal => {
            var $modal = $(modal.element);

            $modal.find('svg').removeAttr('style');

            $modal
                .off('click')
                .on('click', '.product-recommedation-dismiss', e => {
                    e.preventDefault();
                    modal.close();

                    if (
                        e.currentTarget.dataset.eventCategory &&
                        e.currentTarget.dataset.eventAction &&
                        e.currentTarget.dataset.eventLabel
                    ) {
                        triggerEvent(
                            e.currentTarget.dataset.eventCategory,
                            e.currentTarget.dataset.eventAction,
                            e.currentTarget.dataset.eventLabel
                        );
                    }

                    this.dismissById(e.currentTarget.dataset.recommendationProductclassid).done(function () {
                        remove(e.currentTarget.dataset.recommendationProductclassid);
                    });
                })
                .on('click', '.product-recommendations-wishlist', function (e) {
                    e.preventDefault();

                    $.post(
                        '/product/addtowishlist',
                        'productclassId=' + e.currentTarget.dataset.recommendationProductclassid
                    ).done(function () {
                        smartPak.page.redirectToUrl('/wishlist');
                    });
                });
        };
    },
    extendRecommendations: function (recipient) {
        return recipient.suggestions
            .filter(function (recommendation, index, arr) {
                return index === 0 || arr[index - 1].suggestedProductClassId !== recommendation.suggestedProductClassId;
            })
            .map(function (recommendation) {
                return $.extend({}, recommendation, pluckProperties(['accountId', 'accountName'], recipient));
            });
    },
    _buildAffectedRecipientString: function (groups, nameProperty) {
        var DISPLAY_LIMIT = 3,
            recipients = groups.map(pluck(nameProperty)),
            recipientNames,
            lastRecipient;

        if (groups.length < DISPLAY_LIMIT + 1) {
            if (groups.length > 1) {
                lastRecipient = recipients.pop();
                recipientNames = recipients.join(', ') + ' and ' + lastRecipient;
            } else {
                recipientNames = recipients.join(', ');
            }
        } else {
            recipientNames = recipients.slice(0, 3).join(', ') + ', +' + (groups.length - 3) + ' others';
        }

        return recipientNames;
    },
    addResultText: function (groups) {
        var result = groups[0],
            affectedRecipientsText = this._buildAffectedRecipientString(groups, 'accountName');

        result.resultText = 'SmartSuggestion for ' + affectedRecipientsText;
        result.justification = result.bodyCopy.replace(/your horse/gi, affectedRecipientsText);

        return result;
    },
    buildMessage: function (recommendation) {
        return $(
            '<div class="product-recommendation-message">' +
                recommendation.resultText +
                ' <a href="#' +
                this.buildSelector(recommendation) +
                '" class="product-recommendation-more smart-suggestions-modal-trigger" title="SmartSuggestion" data-event-category="' +
                (recommendation.eventCategory || '') +
                '" data-event-action="Click" data-event-label="' +
                (recommendation.ruleName || '') +
                '">(Learn More)</a></div>'
        );
    },
    buildSelector: function (recommendation) {
        return recommendation.accountId.toString().replace(/\W/gi, '-') + '-' + recommendation.suggestedProductClassId;
    },
    format: function (smartSuggestions, ids) {
        var recommendations = smartSuggestions.reduce((arr, recipient) => {
                return arr.concat(this.extendRecommendations(recipient));
            }, []),
            groupedByProductIds;

        if (ids && ids.length) {
            recommendations = recommendations.filter(function (recommendation) {
                return ids.indexOf(recommendation.suggestedProductClassId) > -1;
            });
        }

        groupedByProductIds = groupByProperty(recommendations, 'suggestedProductClassId');

        return Object.keys(groupedByProductIds).reduce((arr, key) => {
            arr.push(this.addResultText(groupedByProductIds[key]));

            return arr;
        }, []);
    }
};

function groupByProperty(arr, property) {
    return arr.reduce(function (obj, item) {
        if (!obj[item[property]]) {
            obj[item[property]] = [];
        }

        obj[item[property]].push(item);

        return obj;
    }, {});
}

function pluckProperties(properties, obj) {
    return properties.reduce(function (result, prop) {
        result[prop] = obj[prop];
        return result;
    }, {});
}

function pluck(prop) {
    return function (obj) {
        return obj[prop];
    };
}

export default smartSuggestions;
